export default "__VITE_PUBLIC_ASSET__3492c2dc__"